// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UPNYI {\n  background-color: var(--color-white);\n  -webkit-box-shadow: var(--schoolinks-shadow);\n          box-shadow: var(--schoolinks-shadow);\n  z-index: 4;\n}\n\n.k9FdN {\n  overflow: auto;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "UPNYI",
	"content": "k9FdN"
};
export default ___CSS_LOADER_EXPORT___;
